import { motion } from "framer-motion";
import { Clock, PackageCheck, Ruler, RotateCw } from "lucide-react";

export const SpecBand = ({ content }) => {
  const specs = [
    { icon: PackageCheck, value: `${content.moq}`, label: "Minimum order quantity", sub: "units per design" },
    { icon: Clock, value: `${content.lead_time_weeks} wks`, label: "Production lead time", sub: "from artwork approval" },
    { icon: Ruler, value: "12", label: "Standard diameters", sub: "Ø40 – Ø147 mm internal" },
    { icon: RotateCw, value: "360°", label: "Full-wrap printing", sub: "your branding, all around" },
  ];
  return (
    <section className="relative bg-[#14171D] border-b border-white/5" data-testid="spec-band">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-2 lg:grid-cols-4">
        {specs.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className="py-10 px-4 sm:px-8 border-l first:border-l-0 border-white/5"
            data-testid={`spec-${i}`}
          >
            <s.icon size={18} className="text-[#D4AF37]" />
            <p className="mt-4 font-serif-display text-3xl sm:text-4xl foil-text font-semibold">{s.value}</p>
            <p className="mt-2 text-[13px] font-medium text-[#F5F3EF]">{s.label}</p>
            <p className="text-[11px] text-[#666F7D] mt-0.5">{s.sub}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
